export const input = {
	default: {
		height: 48,
		width: 280,
		backgroundColor: '#F6F7F8',
		padding: 16,
		borderRadius: 8,
		outlineWidth: 0,
		outlineStyle: 'none',
		borderColor: '#D4D4D4',
		borderWidth: 1,

		inputProps: {
			fontSize: 16,
			lineHeight: 22,
			placeholderTextColor: '#555555',
			color: '#2C2F42',
			fontFamily: 'Source Sans Pro',
		},

		animatedPlaceholderProps: {
			top: 12,
			left: 12,
			fontSize: 16,
			lineHeight: 22,
			color: '#555555',
		},

		animatedInputProps: {
			marginTop: 0,
		},

		focusProps: {
			borderWidth: 1,
			borderColor: '#009E6A',
			animatedPlaceholderProps: {
				top: 4,
				left: 16,
				fontSize: 13,
				lineHeight: 16,
				color: '#555555',
			},

			animatedInputProps: {
				marginTop: 12,
			},
		},
	},

	get error() {
		return {
			...this.default,
			borderWidth: 1,
			borderColor: '#F44335',
		}
	},
}

export const footer = {
	default: {
		height: '100vh',
		width: '100vw',
		backgroundColor: '#000000',
		flexWrap: 'wrap',
		color: '#FFFFFF',
		flexDirection: 'column',

		destinationHeadProps: {
			fontFamily: 'Source Sans Pro',
			fontSize: 16,
			color: '#888888',
		},

		destinationProps: {
			fontFamily: 'Source Sans Pro',
			fontSize: 14,
			color: '#FFFFFF',
			paddingVertical: 6,
			paddingRight: 6,
			cursor: 'pointer',
		},
		iconProps: {
			color: '#FFFFFF',
			width: 16,
			height: 16,
		},
	},
}

export const heroBanner = {
	default: {
		position: 'relative',
		backgroundColor: 'black',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100vw',
		height: '65vh',
		maxWidth: '100%',
		zIindex: -1,
		paddingVertical: 0,
		paddingHorizontal: 12,

		titleProps: {
			width: [300, '50%', '50%'],
			fontFamily: 'Source Sans Pro',
			fontWeight: 550,
			textAlign: 'center',
			fontSize: [24, 28, 32],
			color: '#fff',
			top: 10,
			right: 20,
			lineHeight: [36, 40, 50],
		},

		valueProps: {
			width: '100%',
			height: '100%',
			display: 'flex',
			justifyContent: 'space-evenly',
			backgroundColor: 'rgb(229, 249, 243)',
			paddingVertical: 25,
			paddingHorizontal: 0,
			lineHeight: 24,
			borderBottomLeftRadius: 10,
			borderBottomRightRadius: 10,

			iconProps: {
				fill: 'rgb(0, 139, 92)',
				width: 44,
				height: 44,
				paddingHorizontal: 10,
			},

			textProps: {
				fontFamily: 'Source Sans Pro',
				fontWeight: 600,
				color: 'rgb(68, 68, 68)',
				fontSize: 15,
				lineHeight: 17,
				paddingHorizontal: 10,
			},
		},
	},
}

export const resortCard = {
	default: {
		display: 'flex',
		width: 270,
		height: 289,
		borderRadius: 12,

		imageProps: {
			width: '100%',
			height: '100%',
			position: 'relative',
			borderRadius: 12,
			backgroundColor: '#000',
		},

		dealCardProps: {
			maxHeight: 100,
			width: '100%',
			position: 'absolute',
			bottom: 0,
			left: 15,
			marginBottom: 10,

			destinationProps: {
				color: 'rgb(255, 201, 51)',
				fontFamily: 'Source Sans Pro',
				fontSize: 11,
				fontWeight: 700,
				fontStyle: 'normal',
				width: 90,
				height: 16,
				letterSpacing: 0.33,
				lineHeight: 16,
				textAlign: 'left',
				textTransform: 'uppercase',
			},

			resortProps: {
				color: 'rgb(255, 255, 255)',
				fontFamily: 'Source Sans Pro',
				fontSize: 15,
				fontWeight: 600,
				overflow: 'hidden',
				textAlign: 'left',
				maxWidth: 237,
				maxHeight: 40,
			},

			datelineProps: {
				color: 'rgb(34, 213, 255)',
				display: 'block',
				fontFamily: 'Source Sans Pro',
				fontSize: 13,
				fontWeight: 600,
				fontStyle: 'normal',
				width: '',
				height: 20,
				letterSpacing: 0.26,
				lineHeight: 16,
				textAlign: 'left',
				paddingTop: 4,
			},

			dividerProps: {
				width: 258,
				position: 'absolute',
				left: 6,
				bottom: 71,
				borderBottomWidth: 1,
				borderStyle: 'dashed',
				borderRadius: 12,
				borderColor:
					'linear-gradient(to right, rgb(255, 255, 255) 60%, rgba(255, 255, 255, 0) 20%)',
				zIndex: 99,
			},

			footerProps: {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				minHeight: 72,
				width: 270,
				borderRadius: 12,
				backgroundColor: 'rgb(0, 0, 0)',
				textAlign: 'left',
				marginTop: -1,
				border: 'none',

				dealContentProps: {
					height: 41,
					width: 238,
					display: 'block',
					position: 'absolute',
					top: 15,
					left: 15,

					discountProps: {
						width: 64,
						height: 18,
						paddingVertical: 1,
						paddigHorizontal: 8,
						borderRadius: 4,
						textAlign: 'center',
						backgroundColor: 'rgb(232, 63, 37)',
						color: 'rgb(255, 255, 255)',
						marginRight: 6,
						fontSize: 12,
						lineHeight: 16,
						fontWeight: 500,
					},

					strikedTextProps: {
						fontSize: 15,
						lineHeight: 19,
						color: 'grey',
						fontWeight: 600,
						textDecorationLine: 'line-through',
						textDecorationStyle: 'solid',
					},

					priceProps: {
						fontSize: 18,
						lineHeight: 18,
						fontWeight: 600,
						color: '#fff',
						marginTop: 5,
					},

					deadlineProps: {
						position: 'absolute',
						bottom: 2,
						right: 2,
						width: 120,
						height: 21,
						borderRadius: 4,
						color: '#fff',
						fontWeight: 500,
						fontSize: 9,
						textAlign: 'center',
						paddingVertical: 3,
						paddingHorizontal: 8,
						backgroundColor: 'transparent',
						borderWidth: 1,
						borderColor: 'rgba(255, 255, 255, 0.8)',
						borderStyle: 'dashed',
					},
				},
			},
		},
	},

	lightV1: {
		width: 270,
		height: 289,
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		backgroundColor: '#fff',
		flexDirection: 'column',
		letterSpacing: -0.34,
		borderWidth: 1,
		borderRadius: 12,
		borderColor: 'rgb(229, 229, 229)',

		imageProps: {
			width: 270,
			height: 183,
			position: 'absolute',
			top: 0,
			display: 'block',
			cursor: 'pointer',
			borderTopLeftRadius: 12,
			borderTopRightRadius: 12,
		},

		slideCounterProps: {
			position: 'absolute',
			top: 6,
			right: 6,
			zIndex: 99,
		},

		dealCardProps: {
			maxHeight: 100,
			width: '100%',
			position: 'absolute',
			bottom: 10,
			left: 15,
			marginBottom: 10,

			destinationProps: {
				color: 'rgb(204, 161, 41)',
				fontFamily: 'Source Sans Pro',
				fontSize: 11,
				fontWeight: 700,
				fontStyle: 'normal',
				width: 90,
				height: 16,
				letterSpacing: 0.33,
				lineHeight: 16,
				textAlign: 'left',
				textTransform: 'uppercase',
			},

			resortProps: {
				color: 'rgb(51, 51, 51)',
				fontFamily: 'Source Sans Pro',
				fontSize: 15,
				fontWeight: 600,
				overflow: 'hidden',
				textAlign: 'left',
				maxWidth: 237,
				maxHeight: 40,
			},

			datelineProps: {
				color: 'rgb(224, 55, 81)',
				display: 'block',
				fontFamily: 'Source Sans Pro',
				fontSize: 13,
				fontWeight: 600,
				fontStyle: 'normal',
				width: '',
				height: 20,
				letterSpacing: 0.26,
				lineHeight: 16,
				textAlign: 'left',
				paddingTop: 4,
			},

			dividerProps: {
				width: 258,
				position: 'absolute',
				left: 6,
				bottom: 70,
				borderBottomWidth: 2,
				borderStyle: 'dashed',
				borderRadius: 12,
				borderColor: 'rgb(229, 229, 229)',
				zIndex: 99,
			},

			footerProps: {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				minHeight: 72,
				width: 270,
				borderRadius: 12,
				backgroundColor: 'rgb(255, 255, 255)',
				textAlign: 'left',
				marginTop: -1,
				border: 'none',
				borderLeftWidth: 1,
				borderRightWidth: 1,
				borderBottomWidth: 1,
				borderColor: 'rgb(229, 229, 229)',

				dealContentProps: {
					height: 41,
					width: 238,
					display: 'block',
					position: 'absolute',
					top: 15,
					left: 15,

					discountProps: {
						width: 64,
						height: 18,
						paddingVertical: 1,
						paddigHorizontal: 8,
						borderRadius: 4,
						textAlign: 'center',
						backgroundColor: 'rgb(0, 178, 119)',
						color: 'rgb(255, 255, 255)',
						marginRight: 6,
						fontSize: 12,
						lineHeight: 16,
						fontWeight: 500,
					},

					strikedTextProps: {
						fontSize: 15,
						lineHeight: 19,
						color: 'rgb(119, 119, 119)',
						fontWeight: 600,
						textDecorationLine: 'line-through',
						textDecorationStyle: 'solid',
					},

					priceProps: {
						fontSize: 18,
						lineHeight: 18,
						fontWeight: 600,
						color: '#000',
						marginTop: 5,
					},

					deadlineProps: {
						position: 'absolute',
						bottom: 0,
						right: 2,
						width: 120,
						height: 21,
						borderRadius: 4,
						color: 'rgb(128, 101, 25)',
						fontWeight: 500,
						fontSize: 9,
						textAlign: 'center',
						paddingVertical: 3,
						paddingHorizontal: 8,
						backgroundColor: 'rgb(255, 239, 194)',
						borderWidth: 1,
						borderColor: 'rgb(153, 121, 31)',
						borderStyle: 'dashed',
					},
				},
			},
		},
	},
	lightV2: {
		width: 328,
		height: 376,
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		backgroundColor: '#fff',
		flexDirection: 'column',
		letterSpacing: -0.34,
		borderTopWidth: 1,
		borderLeftWidth: 1,
		borderRightWidth: 1,
		borderTopRightRadius: 12,
		borderTopLeftRadius: 12,
		borderColor: 'rgb(229, 229, 229)',

		imageProps: {
			width: 328,
			height: 212,
			position: 'absolute',
			top: 0,
			display: 'block',
			cursor: 'pointer',
			borderTopLeftRadius: 12,
			borderTopRightRadius: 12,
		},

		slideCounterProps: {
			position: 'absolute',
			right: -10,
			zIndex: 99,
		},

		dealCardProps: {
			maxHeight: 228,
			width: '100%',
			display: 'flex',
			paddingHorizontal: 15,
			position: 'absolute',
			bottom: 35,

			resortProps: {
				color: 'rgb(51, 51, 51)',
				fontFamily: 'Source Sans Pro',
				fontSize: 15,
				fontWeight: 600,
				overflow: 'hidden',
				textAlign: 'left',
				maxWidth: 237,
				maxHeight: 40,
				paddingBottom: 10,
			},

			detailsProps: {
				display: 'flex',

				tripAdvisorProps: {
					display: 'flex',
					width: 59,
					height: 28,
					borderRadius: 25,
					paddingVertical: 4,
					paddingLeft: 8,
					paddingRight: 3,
					backgroundColor: 'rgba(229, 249, 243, 1)',

					tripAdvisorIconProps: {
						width: 18,
						height: 18,
						fill: 'rgba(0, 198, 132, 1)',
					},

					tripAdvisorTextProps: {
						fontSize: 14,
						fontWeight: 600,
						lineHeight: 18,
						color: 'rgba(0, 198, 132, 1)',
					},
				},

				dotProps: {
					width: 4,
					height: 4,
					backgroundColor: 'rgba(212, 212, 212, 1)',
					borderRadius: 50,
				},

				detailsTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 18,
					color: 'rgba(51, 51, 51, 1)',
				},

				detailsIconProps: {
					width: 12,
					height: 12,
					fill: 'rgba(0, 198, 132, 1)',
				},
			},

			roomTextProps: {
				paddingTop: 10,
				fontSize: 14,
				fontWeight: 600,
				lineHeight: 20,
				color: 'rgba(51, 51, 51, 1)',
			},

			amenitiesProps: {
				display: 'flex',
				minHeight: 20,
				width: 326,
				flexWrap: 'wrap',

				amenitiesItemProps: {
					paddingRight: 13,
					paddingTop: 10,
				},
				amenitiesIconProps: {
					width: 18,
					height: 18,
					fill: 'rgba(0, 0, 0, 0.5)',
				},

				amenitiesTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 18,
					color: 'rgba(51, 51, 51, 1)',
				},
			},

			dividerProps: {
				paddingTop: 10,
				borderBottomWidth: 1,
				borderColor: 'rgba(240, 240, 240, 1)',
			},

			footerProps: {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				minHeight: 80,
				width: 328,
				backgroundColor: 'rgb(255, 255, 255)',
				textAlign: 'left',
				marginTop: -1,
				border: 'none',
				borderLeftWidth: 1,
				borderRightWidth: 1,
				borderBottomWidth: 1,
				borderBottomLeftRadius: 12,
				borderBottomRightRadius: 12,
				borderColor: 'rgb(229, 229, 229)',
				paddingHorizontal: 10,

				dealContentProps: {
					height: 50,
					width: 238,
					position: 'absolute',
					top: 15,
					left: 15,
					display: 'flex',
					justifyContent: 'space-between',
					paddingTop: 10,

					cancellationProps: {
						width: 156,
						height: 32,
						borderRadius: 28,
						paddingVertical: 8,
						paddingLeft: 6,
						backgroundColor: 'rgba(229,249,243,1)',

						cancellationTextProps: {
							fontSize: 11,
							fontWeight: 700,
							lineHeight: 15,
							color: 'rgba(0, 178, 119, 1)',
						},
					},

					discountProps: {
						width: 64,
						height: 19,
						paddingVertical: 1,
						paddigHorizontal: 8,
						borderRadius: 4,
						textAlign: 'center',
						backgroundColor: 'rgb(239, 67, 93)',
						color: 'rgb(255, 255, 255)',
						marginRight: 6,
						fontSize: 12,
						lineHeight: 16,
						fontWeight: 500,
					},

					strikedTextProps: {
						fontSize: 15,
						lineHeight: 19,
						color: 'rgb(119, 119, 119)',
						fontWeight: 600,
						textDecorationLine: 'line-through',
						textDecorationStyle: 'solid',
					},

					priceProps: {
						fontSize: 18,
						lineHeight: 18,
						fontWeight: 600,
						color: '#000',
						marginTop: 5,

						nightProps: {
							fontSize: 14,
							lineHeight: 18,
							fontWeight: 400,
							color: 'rgb(51, 51, 51)',
							marginTop: 5,
						},
					},
				},
			},
		},
	},
	lightV3: {
		width: '100%',
		minHeight: 310,
		backgroundColor: '#fff',
		borderTopWidth: 1,
		borderLeftWidth: 1,
		borderRightWidth: 1,
		borderTopRightRadius: 12,
		borderTopLeftRadius: 12,
		borderColor: 'rgb(229, 229, 229)',

		imageProps: {
			width: '100%',
			height: 212,
			position: 'absolute',
			top: 0,
			display: 'block',
			cursor: 'pointer',
			borderTopLeftRadius: 12,
			borderTopRightRadius: 12,
		},

		dealCardProps: {
			width: '100%',
			paddingTop: 10,
			paddingHorizontal: 15,

			resortProps: {
				color: 'rgb(51, 51, 51)',
				fontSize: 17,
				fontWeight: 600,
				overflow: 'hidden',
				maxWidth: 237,
				maxHeight: 40,
				paddingBottom: 10,
			},

			detailsProps: {
				display: 'flex',
				maxWidth: 326,
				flexWrap: 'wrap',

				tripAdvisorProps: {
					display: 'flex',
					justifyContent: 'flex-end',
					height: 28,
					borderRadius: 25,
					paddingVertical: 5,
					paddingLeft: 10,
					paddingRight: 10,
					backgroundColor: 'rgba(229, 249, 243, 1)',

					tripAdvisorIconProps: {
						width: 15,
						height: 15,
						fill: 'rgba(0, 198, 132, 1)',
					},

					tripAdvisorTextProps: {
						fontSize: 12,
						fontWeight: 600,
						lineHeight: 18,
						color: 'rgba(0, 198, 132, 1)',
					},
				},

				roomLeftProps: {
					display: 'flex',
					height: 28,
					borderRadius: 28,
					paddingVertical: 6,
					paddingHorizontal: 12,
					backgroundColor: 'rgba(253, 236, 239, 1)',

					roomLeftTextProps: {
						fontSize: 12,
						fontWeight: 600,
						lineHeight: 16,
						color: 'rgba(215, 60, 84, 1)',
					},
				},

				dotProps: {
					width: 4,
					height: 4,
					backgroundColor: 'rgba(212, 212, 212, 1)',
					borderRadius: 50,
				},

				detailsTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 22,
					maxWidth: 316,
					maxHeight: 200,
					color: 'rgba(51, 51, 51, 1)',
				},

				detailsIconProps: {
					width: 12,
					height: 12,
					fill: 'rgba(0, 198, 132, 1)',
				},
			},

			roomTextProps: {
				paddingTop: 10,
				fontSize: 14,
				fontWeight: 600,
				lineHeight: 20,
				maxWidth: 310,
				flexWrap: 'wrap',
				color: 'rgba(51, 51, 51, 1)',

				roomTypeTextProps: {
					paddingTop: 10,
					fontSize: 11,
					fontWeight: 400,
					lineHeight: 12,
					color: 'rgba(102, 102, 102, 1)',
				},
			},

			dividerProps: {
				paddingTop: 10,
				borderBottomWidth: 1,
				borderColor: 'rgba(240, 240, 240, 1)',
			},

			footerProps: {
				minHeight: 80,
				backgroundColor: 'rgb(255, 255, 255)',
				border: 'none',
				borderLeftWidth: 1,
				borderRightWidth: 1,
				borderBottomWidth: 1,
				borderBottomLeftRadius: 12,
				borderBottomRightRadius: 12,
				borderColor: 'rgb(229, 229, 229)',
				paddingHorizontal: 10,

				dealContentProps: {
					minHeight: 42,
					width: '100%',
					display: 'flex',

					cancellationProps: {
						borderRadius: 28,
						paddingTop: 15,
						paddingLeft: 6,

						cancellationTextProps: {
							fontSize: 13,
							fontWeight: 700,
							lineHeight: 16,
							color: 'rgba(0, 178, 119, 1)',
						},
					},
					checkInProps: {
						display: 'flex',
						paddingLeft: 3,
						paddingTop: 2,

						checkInTextProps: {
							fontSize: 10,
							fontWeight: 500,
							lineHeight: 12,
							color: 'rgba(0, 178, 119, 1)',
						},
					},

					discountProps: {
						width: 64,
						height: 19,
						paddingVertical: 1,
						paddigHorizontal: 8,
						borderRadius: 4,
						textAlign: 'center',
						backgroundColor: 'rgb(239, 67, 93)',
						color: 'rgb(255, 255, 255)',
						marginRight: 6,
						fontSize: 12,
						lineHeight: 16,
						fontWeight: 600,
						marginTop: 10,
					},

					strikedTextProps: {
						marginTop: 10,
						fontSize: 16,
						lineHeight: 20,
						color: 'rgb(119, 119, 119)',
						fontWeight: 600,
						textDecorationLine: 'line-through',
						textDecorationStyle: 'solid',
					},

					priceProps: {
						fontSize: 20,
						lineHeight: 20,
						fontWeight: 600,
						color: '#000',
						marginTop: 5,

						nightProps: {
							fontSize: 12,
							lineHeight: 16,
							fontWeight: 400,
							color: 'rgba(51, 51, 51, 1)',
							marginTop: 5,
						},
					},
				},
			},
		},
	},
	darkV1: {
		width: '100%',
		height: 376,
		display: 'flex',
		flexDirection: 'column',
		borderTopRightRadius: 12,
		borderTopLeftRadius: 12,

		imageProps: {
			width: '100%',
			height: 376,
			position: 'absolute',
			top: 0,
			display: 'block',
			cursor: 'pointer',
			borderTopLeftRadius: 12,
			borderTopRightRadius: 12,
		},

		dealCardProps: {
			maxHeight: 228,
			width: '100%',
			paddingHorizontal: 15,
			position: 'absolute',
			bottom: 35,

			resortProps: {
				color: 'rgba(255, 255, 255, 1)',
				fontSize: 17,
				fontWeight: 600,
				overflow: 'hidden',
				maxWidth: 237,
				maxHeight: 40,
				paddingBottom: 10,
			},
			detailsProps: {
				display: 'flex',
				flex: 1,
				flexWrap: 'wrap',

				tripAdvisorProps: {
					display: 'flex',
					justifyContent: 'flex-end',
					height: 28,
					borderRadius: 25,
					paddingVertical: 5,
					paddingLeft: 10,
					paddingRight: 10,
					backgroundColor: 'rgba(229, 249, 243, 1)',

					tripAdvisorIconProps: {
						width: 15,
						height: 15,
						fill: 'rgba(0, 198, 132, 1)',
					},

					tripAdvisorTextProps: {
						fontSize: 12,
						fontWeight: 600,
						lineHeight: 18,
						color: 'rgba(0, 198, 132, 1)',
					},
				},

				roomLeftProps: {
					display: 'flex',
					height: 28,
					borderRadius: 28,
					paddingVertical: 6,
					paddingHorizontal: 12,
					backgroundColor: 'rgba(253, 236, 239, 1)',

					roomLeftTextProps: {
						fontSize: 12,
						fontWeight: 600,
						lineHeight: 18,
						color: 'rgba(215, 60, 84, 1)',
					},
				},

				dotProps: {
					width: 4,
					height: 4,
					backgroundColor: 'rgba(212, 212, 212, 1)',
					borderRadius: 50,
				},

				detailsTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 22,
					maxWidth: 300,
					maxHeight: 200,
					color: 'rgba(255, 255, 255, 1)',
				},

				detailsIconProps: {
					width: 12,
					height: 12,
					fill: 'rgba(0, 198, 132, 1)',
				},
			},
			roomTextProps: {
				paddingTop: 10,
				fontSize: 14,
				fontWeight: 600,
				lineHeight: 20,
				maxWidth: 326,
				color: 'rgba(255, 255, 255, 1)',

				roomTypeTextProps: {
					paddingTop: 10,
					fontSize: 11,
					fontWeight: 400,
					lineHeight: 12,
					color: 'rgba(229, 229, 229, 1)',
				},
			},

			dividerProps: {
				// paddingTop: 10,
				// width: '100%',
				// borderBottomWidth: 1,
				// borderColor: 'rgba(195, 195, 195, 0.5)',
			},

			footerProps: {
				minHeight: 80,
				backgroundColor: '#11212E',
				border: 'none',

				borderBottomLeftRadius: 12,
				borderBottomRightRadius: 12,
				paddingHorizontal: 10,

				dealContentProps: {
					minHeight: 42,
					width: '100%',
					display: 'flex',

					cancellationProps: {
						borderRadius: 28,
						paddingTop: 15,
						paddingLeft: 6,

						cancellationTextProps: {
							fontSize: 13,
							fontWeight: 700,
							lineHeight: 16,
							color: 'rgba(38, 207, 150, 1)',
						},
					},
					checkInProps: {
						display: 'flex',
						paddingLeft: 3,
						paddingTop: 2,

						checkInTextProps: {
							fontSize: 10,
							fontWeight: 500,
							lineHeight: 12,
							color: 'rgba(38, 207, 150, 1)',
						},
					},

					discountProps: {
						width: 64,
						height: 19,
						paddingVertical: 1,
						paddigHorizontal: 8,
						borderRadius: 4,
						textAlign: 'center',
						backgroundColor: 'rgb(239, 67, 93)',
						color: 'rgb(255, 255, 255)',
						marginRight: 6,
						fontSize: 12,
						lineHeight: 16,
						fontWeight: 600,
					},

					strikedTextProps: {
						fontSize: 16,
						lineHeight: 20,
						color: 'rgba(195, 195, 195, 1)',
						fontWeight: 600,
						textDecorationLine: 'line-through',
						textDecorationStyle: 'solid',
					},

					priceProps: {
						fontSize: 20,
						lineHeight: 20,
						fontWeight: 600,
						color: 'rgba(255, 255, 255, 1)',
						marginTop: 5,

						nightProps: {
							fontSize: 12,
							lineHeight: 16,
							fontWeight: 400,
							color: 'rgba(195, 195, 195, 1)',
							marginTop: 5,
						},
					},
				},
			},
		},
	},
}
export const propertyCard = {
	default: {
		height: 220,
		display: 'flex',
		backgroundColor: '#fff',
		borderRadius: 12,
		shadowRadius: 12,
		shadowOpacity: 1,
		shadowOffset: {
			width: 0,
			height: 2,
		},
		shadowColor: 'rgba(31, 38, 61, 0.11)',

		imageProps: {
			width: '30%',
			height: '100%',
		},

		centerSectionProps: {
			width: '45%',
			direction: 'column',
			padding: 24,
			paddingBottom: 16,
			gutter: [6, 6, 'auto'],

			resortProps: {
				fontSize: 20,
				fontWeight: 600,
				lineHeight: 25,
				color: 'rgba(51, 51, 51, 1)',
			},

			detailsProps: {
				textProps: {
					fontSize: 14,
					maxWidth: 300,
					fontWeight: 400,
					lineHeight: 20,
					color: 'rgba(102, 102, 102, 1)',
				},
				separatorProps: {
					width: 4,
					height: 4,
					backgroundColor: 'rgba(195, 195, 195, 1)',
					borderRadius: 50,
				},
			},

			roomProps: {
				paddingTop: 10,
				fontSize: 14,
				maxWidth: 300,
				fontWeight: 600,
				lineHeight: 20,
				color: 'rgba(51, 51, 51, 1)',
			},

			roomCountProps: {
				paddingTop: 10,
				fontSize: 11,
				fontWeight: 400,
				lineHeight: 12,
				color: 'rgba(102, 102, 102, 1)',
			},
		},

		rightSectionProps: {
			width: '25%',
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			alignItems: 'baseline',
			padding: 24,
			paddingBottom: 16,
			borderLeftColor: '#F0F0F0',
			borderLeftWidth: 1,

			cancellationTextProps: {
				fontSize: 13,
				fontWeight: 600,
				lineHeight: 15,
				color: 'rgba(0, 178, 119, 1)',
			},

			cancellationBeforeTextProps: {
				fontSize: 10,
				fontWeight: 500,
				lineHeight: 12,
				color: 'rgba(0, 178, 119, 1)',
			},

			discountProps: {
				width: 64,
				height: 19,
				paddingVertical: 1,
				paddigHorizontal: 8,
				borderRadius: 4,
				textAlign: 'center',
				backgroundColor: 'rgb(239, 67, 93)',
				color: 'rgb(255, 255, 255)',
				marginRight: 6,
				fontSize: 12,
				lineHeight: 16,
				fontWeight: 500,
			},

			strikedPriceProps: {
				fontSize: 15,
				lineHeight: 19,
				color: 'rgb(119, 119, 119)',
				fontWeight: 600,
				textDecorationLine: 'line-through',
				textDecorationStyle: 'solid',
			},

			priceProps: {
				fontSize: 20,
				lineHeight: 18,
				fontWeight: 700,
				color: '#000',
				marginTop: 5,
			},

			paxProps: {
				fontSize: 11,
				lineHeight: 18,
				fontWeight: 400,
				color: 'rgb(51, 51, 51)',
				marginTop: 5,
			},

			ctaProps: {
				width: 144,
				zIndex: 999,
				height: 40,
				borderRadius: 12,
				paddingVertical: 10,
				paddingHorizontal: 20,
				backgroundColor: 'rgba(0, 198, 132, 1)',
				transition: 'all 1s ease',
				transform: [{ translateY: -1 }],

				textProps: {
					fontSize: 12,
					fontWeight: 600,
					lineHeight: 20,
					color: 'rgba(255, 255, 255, 1)',
					numberOfLines: 1,
				},
			},
		},
	},
	dark: {
		height: 220,
		display: 'flex',
		backgroundColor: '#fff',
		borderRadius: 12,
		shadowRadius: 12,
		shadowOpacity: 1,
		shadowOffset: {
			width: 0,
			height: 2,
		},
		shadowColor: 'rgba(31, 38, 61, 0.11)',

		imageProps: {
			width: 360,
			height: 220,
			position: 'absolute',
			top: 0,
			display: 'block',
			cursor: 'pointer',
			borderTopLeftRadius: 12,
			borderBottomLeftRadius: 12,
		},

		centerSectionProps: {
			width: '45%',
			direction: 'column',
			padding: 24,
			paddingBottom: 16,
			gutter: [6, 6, 'auto'],
			marginLeft: 'auto',

			resortProps: {
				fontSize: 20,
				fontWeight: 600,
				lineHeight: 25,
				color: 'rgba(255, 255, 255, 1)',
			},

			detailsProps: {
				display: 'flex',
				flexWrap: 'wrap',

				textProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 20,
					color: 'rgba(255, 255, 255, 1)',
				},
				separatorProps: {
					width: 4,
					height: 4,
					backgroundColor: 'rgba(153, 153, 153, 1)',
					borderRadius: 50,
				},
			},

			roomProps: {
				fontSize: 14,
				maxWidth: 300,
				fontWeight: 600,
				lineHeight: 20,
				color: 'rgba(255, 255, 255, 1)',
			},

			roomCountProps: {
				fontSize: 11,
				fontWeight: 400,
				lineHeight: 12,
				color: 'rgba(229, 229, 229, 1)',
			},
		},

		rightSectionProps: {
			width: '25%',
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			alignItems: 'baseline',
			padding: 24,
			paddingBottom: 16,
			borderLeftColor: 'rgba(255, 255, 255, 0.2)',
			borderLeftWidth: 1,

			cancellationTextProps: {
				fontSize: 13,
				fontWeight: 600,
				lineHeight: 15,
				color: 'rgba(38, 207, 150, 1)',
			},

			cancellationBeforeTextProps: {
				fontSize: 10,
				fontWeight: 500,
				lineHeight: 12,
				color: 'rgba(38, 207, 150, 1)',
			},

			discountProps: {
				width: 64,
				height: 19,
				paddingVertical: 1,
				paddigHorizontal: 8,
				borderRadius: 4,
				textAlign: 'center',
				backgroundColor: 'rgba(239, 67, 93, 1)',
				color: 'rgb(255, 255, 255)',
				marginRight: 6,
				fontSize: 12,
				lineHeight: 16,
				fontWeight: 500,
			},

			strikedPriceProps: {
				fontSize: 15,
				lineHeight: 19,
				color: 'rgba(195, 195, 195, 1)',
				fontWeight: 600,
				textDecorationLine: 'line-through',
				textDecorationStyle: 'solid',
			},

			priceProps: {
				fontSize: 20,
				lineHeight: 18,
				fontWeight: 700,
				color: 'rgba(255, 255, 255, 1)',
				marginTop: 5,
			},

			paxProps: {
				fontSize: 11,
				lineHeight: 18,
				fontWeight: 400,
				color: 'rgba(195, 195, 195, 1)',
				marginTop: 5,
			},

			ctaProps: {
				width: 144,
				zIndex: 999,
				height: 40,
				borderRadius: 12,
				paddingVertical: 10,
				paddingHorizontal: 20,
				backgroundColor: 'rgba(0, 198, 132, 1)',
				transition: 'all 1s ease',
				transform: [{ translateY: -1 }],

				textProps: {
					fontSize: 12,
					fontWeight: 600,
					lineHeight: 20,
					color: 'rgba(255, 255, 255, 1)',
					numberOfLines: 1,
				},
			},
		},
	},
}

export const slider = {
	default: {
		leftIconProps: {
			width: 44,
			height: 44,
			backgroundColor: 'rgb(255, 255, 255)',
			borderRadius: '100%',
			borderColor: 'rgba(0, 0, 0, 0)',
			zIndex: 1,
			overflow: 'visible',
			shadowColor: 'rgba(0, 0, 0, 0.2)',
			shadowRadius: 10,
			shadowOpacity: 1,
			color: '#148099',
			position: 'absolute',
		},
		rightIconProps: {
			width: 44,
			height: 44,
			backgroundColor: 'rgb(255, 255, 255)',
			borderRadius: '100%',
			borderColor: 'rgba(0, 0, 0, 0)',
			zIndex: 1,
			overflow: 'visible',
			shadowColor: 'rgba(0, 0, 0, 0.2)',
			shadowRadius: 10,
			shadowOpacity: 1,
			color: '#148099',
			position: 'absolute',
		},
		wrapperProps: {
			flexDirection: 'row',
			paddingRight: 24,
		},
	},
}

export const dealsCard = {
	default: {
		height: 420,
		width: 566,
		justifyContent: 'center',
		position: 'relative',
		backgroundProps: {
			height: 420,
			width: 566,
			borderRadius: 8,
		},
		textProps: {
			color: '#fff',
			fontWeight: '700',
			paddingVertical: 30,
			fontSize: 30,
			flex: 1,
			width: 400,
			lineHeight: 40,
			textAlign: 'center',
		},
		logoProps: {
			paddingVertical: 20,
			cursor: 'pointer',
			alignSelf: 'center',
		},
		actionProps: {
			paddingVertical: 40,
			textAlign: 'center',
		},
	},
}

export const guidelineCard = {
	default: {
		backgroundColor: '#E5F9F3',
		width: '100%',
		borderRadius: '8px',
		padding: ['24px', '', '25px'],
		direction: 'vertical',
		alignItems: [null, '', 'center'],
		justifyContent: 'center',
		gutter: [16, 0, 16],

		buttonProps: {
			alignSelf: ['flex-start', 'center'],
		},
		titleProps: {
			fontSize: ['15px', '', '24px'],
			lineHeight: ['24px', '', '32px'],
			margin: 0,
			fontWeight: 600,
			paddingBottom: [12, 8, 8],
		},
		subTitleProps: {
			fontSize: '18px',
			lineHeight: '28px',
			margin: 0,
			paddingBottom: [30, 20, 20],
			fontWeight: 400,
		},
	},
}
export const destinationCard = {
	default: {
		height: '100%',
		width: '100%',
		position: 'relative',
		direction: 'column',
		justifyContent: 'flex-end',
		paddingBottom: 10,
		paddingLeft: 6,
		paddingRight: 4,

		titleProps: {
			color: '#fff',
			fontSize: 16,
			lineHeight: 1.3,
			letterSpacing: '-0.25px',
			marginBottom: '10px',
		},
		costProps: {
			color: '#fff',
			fontSize: 13,
			lineHeight: 1.23,
			letterSpacing: '-0.25px',
		},
		logoProps: {
			paddingVertical: 20,
			cursor: 'pointer',
			alignSelf: 'center',
		},
		actionProps: {
			paddingVertical: 40,
			textAlign: 'center',
		},
	},
}
export const button = {
	secondary: {
		backgroundColor: 'grey04',
		color: '#FFFFFF',
		borderRadius: 8,
		height: '40px',
		minWidth: '160px',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		textVariant: 'button-small',
		loadingText: 'Please wait...',
		hoverStyle: { backgroundColor: 'grey03' },
		textProps: {
			color: '#01C684',
			fontWeight: 700,
		},
		disabledProps: {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
		loadingProps: {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	primary: {
		backgroundColor: '#01C684',
		borderRadius: 8,
		height: '40px',
		paddingHorizontal: 22,
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		alignSelf: 'center',
		loadingText: 'Please wait...',
		hoverStyle: { backgroundColor: '#fff' },
		textProps: {
			color: '#fff',
			fontWeight: 700,
		},
		disabledProps: {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
		loadingProps: {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	get default() {
		return this.primary
	},
}

export const datePicker = {
	default: {
		webProps: {
			popperProps: {
				width: 350,
				padding: 16,
				backgroundColor: 'rgba(255, 255, 255, 1)',
				borderRadius: 12,
			},
			dayProps: {
				width: 44,
				height: 44,
				borderRadius: 8,
				textProps: {
					variant: 'small',
					color: 'rgba(119, 119, 119, 1)',
					fontWeight: 400,
				},
			},
			dateProps: {
				width: 44,
				height: 44,
				borderRadius: 8,
				hoverStyle: {
					backgroundColor: 'rgba(229, 249, 243, 1)',
				},
				textProps: {
					variant: 'small',
					color: 'rgba(51, 51, 51, 1)',
					fontWeight: 600,
				},
			},
			activeProps: {
				backgroundColor: 'rgba(0, 119, 79, 1)',
				hoverStyle: {
					backgroundColor: 'rgba(0, 119, 79, 1)',
				},
				textProps: {
					color: 'rgba(255, 255, 255, 1)',
				},
			},
			headingProps: {
				paddingBottom: 2,
				textProps: {
					variant: 'small',
					fontWeight: 600,
					color: 'rgba(85, 85, 85, 1)',
				},
				hoverStyle: {
					textDecorationLine: 'underline',
					textDecorationColor: '#000',
				},
			},
			iconProps: {
				width: 36,
				height: 36,
				borderRadius: 8,
				alignItems: 'center',
				justifyContent: 'center',
				hoverStyle: {
					backgroundColor: 'rgba(240, 240, 240, 1)',
					borderRadius: 50,
				},
				svgProps: {
					width: 14,
					height: 14,
					fill: 'rgba(51, 51, 51, 1)',
				},
			},
		},
		mobileProps: {
			bottomSheetProps: {
				borderRadius: 8,
			},
			dayProps: {
				width: '14.25%',
				height: 44,
				borderRadius: 8,
				textProps: {
					variant: 'small',
					color: 'rgba(119, 119, 119, 1)',
				},
			},
			monthProps: {
				textProps: {
					color: 'rgba(85, 85, 85, 1)',
					fontSize: 17,
					variant: 'small',
					fontWeight: 600,
				},
			},
			yearProps: {
				textProps: {
					color: 'rgba(85, 85, 85, 1)',
					fontSize: 17,
					variant: 'small',
					fontWeight: 600,
				},
			},
			dateProps: {
				width: '14.25%',
				height: 44,
				borderRadius: 8,
				hoverStyle: {
					backgroundColor: 'rgba(229, 249, 243, 1)',
				},
				textProps: {
					variant: 'small',
					color: 'rgba(51, 51, 51, 1)',
					fontWeight: 600,
				},
			},
			activeProps: {
				backgroundColor: 'rgba(0, 119, 79, 1)',
				hoverStyle: {
					backgroundColor: 'rgba(0, 119, 79, 1)',
				},
				textProps: {
					color: 'rgba(255, 255, 255, 1)',
				},
			},
			headingProps: {
				paddingBottom: 2,
				borderBottomColor: 'rgba(85, 85, 85, 1)',
				textProps: {
					color: 'rgba(51, 51, 51, 1)',
					fontSize: 17,
					variant: 'small',
					fontWeight: 600,
				},
				hoverStyle: {
					textDecorationLine: 'underline',
					textDecorationColor: '#FFFFFF',
				},
			},
			iconProps: {
				width: 36,
				height: 36,
				borderRadius: 8,
				alignItems: 'center',
				justifyContent: 'center',
				hoverStyle: {
					backgroundColor: 'grey04',
				},
				svgProps: {
					width: 12,
					height: 12,
					fill: '#65656B',
				},
			},
			borderProps: {
				borderBottomWidth: 1,
				borderColor: 'rgba(240, 240, 240, 1)',
			},
		},
	},
}

export const bottomSheet = {
	default: {
		borderTopLeftRadius: 16,
		borderTopRightRadius: 16,
	},
	borderLess: {
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
	},
}

export const bankOfferCard = {
	default: {
		width: 280,
		height: 157,
		borderRadius: 8,

		contentProps: {
			paddingTop: 25,
			paddingLeft: 10,
			paddingBottom: 10,

			titleProps: {
				fontSize: 14,
				fontWeight: 700,
				lineHeight: 20,
				letterSpacing: 0.4,
				color: 'rgba(255, 255, 255, 1)',
			},

			subtitleProps: {
				fontSize: 14,
				fontWeight: 400,
				lineHeight: 20,
				color: 'rgba(255, 255, 255, 0.8)',
				width: 220,
			},

			ctaLeftProps: {
				width: 100,
				height: 40,
				borderRadius: 4,
				backgroundColor: 'rgba(255, 255, 255, 1)',
				paddingTop: 15,
				paddingLeft: 12,

				ctaLeftTextProps: {
					fontSize: 12,
					fontWeight: 600,
					lineHeight: 10,
					color: 'rgba(0, 0, 0, 1)',
				},
			},
			ctaRightProps: {
				fontSize: 14,
				fontWeight: 400,
				lineHeight: 17,
				color: 'rgba(255, 255, 255, 0.66)',
				textDecorationLine: 'underline',
				textDecorationStyle: 'solid',
			},
		},
		bankBadgeProps: {
			position: 'absolute',
			top: -92,
			left: 170,
			display: 'flex',
			width: 85,
			height: 38,
			borderRadius: 28,
			borderLeftWidth: 2,
			borderRightWidth: 2,
			borderBottomWidth: 2,
			borderColor: 'rgba(255, 255, 255, 1)',
			backgroundColor: 'rgba(0, 0, 0, 1)',
			paddingLeft: 10,

			bankIconProps: {
				width: 18,
				height: 18,
			},
			bankTextProps: {
				fontSize: 13,
				fontWeight: 600,
				lineHeight: 16,
				color: 'rgba(255, 255, 255, 1)',
			},
		},
	},
}

export const filterSection = {
	default: {
		marginVertical: 10,
		direction: 'column',
		fontFamily: 'Source Sans Pro',

		titleProps: {
			fontSize: 17,
			fontWeight: 600,
			paddingVertical: 10,
			color: '#00000',
		},
		checkBoxProps: {
			checkedProps: { fill: 'green' },
		},
		labelProps: {
			color: '#00000',
			fontWeight: 400,
			fontSize: 16,
		},
		renderTextProps: {
			fontSize: 16,
			fontWeight: 600,
			fontFamily: 'Source Sans Pro',
			color: '#000000',
		},
	},
}
export const radioButton = {
	default: {
		width: 20,
		height: 20,
		alignItems: 'center',
		justifyContent: 'center',
		style: {
			cursor: 'pointer',
		},
		checkedProps: {
			fill: '#00774F',
		},
		disabledProps: {
			style: {
				opacity: 0.5,
				cursor: 'not-allowed',
			},
		},
	},
}

export const checkbox = {
	default: {
		width: 20,
		height: 20,
		fill: 'grey',
		style: {
			cursor: 'pointer',
		},
		checkedProps: {
			fill: '#00774F',
		},
		disabledProps: {
			style: {
				opacity: 0.5,
				cursor: 'not-allowed',
			},
		},
	},
	primary: {
		width: 20,
		height: 20,
		fill: 'grey',
		style: {
			cursor: 'pointer',
		},
		checkedProps: {
			fill: '#00774F',
		},
		disabledProps: {
			style: {
				opacity: 0.5,
				cursor: 'not-allowed',
			},
		},
	},
}
export const groupButton = {
	default: {
		itemProps: {
			minWidth: 'auto',
			textProps: {
				color: 'grey00',
			},
			textVariant: 'tiny',
			borderWidth: 1,
			borderColor: 'grey02',
			borderRadius: 4,
			backgroundColor: 'transparent',
			height: 32,
			paddingVertical: 8,
			paddingHorizontal: 12,
		},

		activeProps: {
			borderColor: 'primary01',
			textProps: {
				color: 'primary01',
			},
		},
	},

	primary: {
		itemProps: {
			minWidth: 56,
			minHeight: 52,
			textProps: {
				color: '#000000',
			},
			textVariant: 'tiny',
			borderWidth: 1,
			borderColor: '#D4D4D4',
			borderRadius: 4,
			backgroundColor: 'transparent',
			paddingVertical: 0,
			paddingHorizontal: 0,
		},

		activeProps: {
			borderColor: '#ffffff',
			textProps: {
				color: '#ffffff',
			},
			backgroundColor: '#00774F',
		},
	},

	get error() {
		return {
			...this.default,
			borderWidth: 1,
			borderColor: '#F44335',
		}
	},
}

export const paxConfig = {
	default: {
		contentWrapper: {
			paddingHorizontal: 23,
			paddingTop: 16,
		},
		titleProps: {
			fontWeight: 600,
			fontSize: 17,
			lineHeight: 16,
			color: '#333333',
		},
		configTitleContainer: {
			backgroundColor: '#E5F9F3',
			height: 54,
			alignItems: 'center',
		},
		configSubTitleProps: {
			fontWeight: 600,
			fontSize: 15,
			lineHeight: 19,
			color: '#00774F',
		},
		configTextProps: {
			fontWeight: 400,
			fontSize: 17,
			lineHeight: 21,
			color: '#333333',
		},
	},
}
export const select = {
	default: {
		inputProps: {
			width: '100%',
		},
		drawerProps: {},
		webProps: {
			popperProps: {
				paddingVertical: 8,
				backgroundColor: 'white',
				borderRadius: 8,
				height: 300,
			},
			optionProps: {
				width: '100%',
				height: 40,
				paddingVertical: 8,
				paddingHorizontal: 16,
				textProps: {
					color: '#000000',
				},
			},
			hoverProps: {
				backgroundColor: '#01C684',
				textProps: {
					color: '#ffffff',
				},
			},
			drawerProps: {},
			// activeProps: {
			// 	textProps: {
			// 		color: '#ffffff',
			// 	},
			// },
		},
		mobileProps: {
			bottomSheetProps: {
				optionProps: {
					width: '100%',
					height: 40,
					paddingVertical: 20,
					paddingHorizontal: 16,
					textProps: {
						variant: 'small',
						color: 'grey',
					},
				},
			},
		},
	},
}
export const ribbon = {
	default: {},
}

export const text = {
	default: {
		fontFamily: 'Source Sans Pro',
	},
}

export const tabs = {
	default: {
		borderBottomColor: '#F2F2F2',
		itemProps: {
			color: 'grey02',
			textVariant: 'small',
			spaceBetweenItems: '55px',
		},
		activeProps: {
			color: 'primary01',
		},
	},
}
export const pill = {
	default: {
		backgroundColor: 'grey03',
		borderRadius: 8,
		alignItems: 'center',

		textProps: {
			color: 'grey02',
			textAlign: 'center',
			fontSize: 16,
			fontWeight: 600,
		},
	},
}
export const propertyDetailsCard = {
	default: {
		borderRadius: 12,
		width: '100%',
		// shadowOpacity: 0.2,
		// shadowRadius: 12,
		// shadowOffset: {
		// 	height: 3,
		// 	width: 3,
		// },
		minHeight: 2,
		display: 'block',
		backgroundColor: '#fff',

		imageSectionProps: {
			width: '100%',

			imageProps: {
				width: '100%',
				height: 148,
				position: 'relative',
				top: 0,
				display: 'block',
				cursor: 'pointer',
				borderTopLeftRadius: 12,
				borderTopRightRadius: 12,
			},
		},

		detailsSectionProps: {
			width: '100%',
			position: 'relative',

			resortProps: {
				paddingLeft: 16,
				paddingTop: 12,
				fontSize: 17,
				fontWeight: 600,
				lineHeight: 25,
				color: 'rgba(51, 51, 51, 1)',
			},

			amenitiesProps: {
				display: 'flex',
				paddingLeft: 16,
				minHeight: 20,
				maxWidth: 350,
				flexWrap: 'wrap',

				amenitiesItemProps: {
					paddingRight: 13,
					paddingTop: 12,
				},
				amenitiesIconProps: {
					width: 18,
					height: 18,
					fill: 'rgba(0, 0, 0, 0.5)',
				},

				amenitiesTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 18,
					color: 'rgba(51, 51, 51, 1)',
				},
			},

			viewMoreProps: {
				paddingVertical: 20,
				paddingLeft: 16,

				viewMoreTextProps: {
					fontSize: 14,
					fontWeight: 600,
					lineHeight: 18,
					color: 'rgba(51, 51, 51, 1)',
				},
				viewMoreIconProps: {
					width: 14,
					height: 14,
					fill: 'rgba(51, 51, 51, 1)',
				},
			},
		},

		specialInclusionProps: {
			width: '100%',
			paddingLeft: 22,
			paddingTop: 16,
			paddingBottom: 20,
			backgroundColor: 'rgba(208, 244, 229, 1)',

			specialInclusionHeadingProps: {
				fontSize: 15,
				fontWeight: 600,
				lineHeight: 22,
				color: 'rgba(0, 119, 79, 1)',
				paddingBottom: 12,
			},
			specialInclusionIconProps: {
				width: 15,
				height: 15,
			},
			specialInclusionTextProps: {
				fontSize: 14,
				lineHeight: 22,
				fontWeight: 400,
				minHeight: 25,
				maxWidth: 280,
			},
		},

		priceSectionProps: {
			direction: 'column',
			minHeight: 122,
			width: '100%',
			borderBottomWidth: 1,
			borderBottomColor: 'rgba(240, 240, 240, 1)',

			leftSectionProps: {
				paddingVertical: 15,
				width: '60%',
				priceTextProps: {
					fontSize: 17,
					fontWeight: 700,
					lineHeight: 22,
					color: 'rgba(51, 51, 51, 1)',
					paddingBottom: 12,
				},

				inclusionTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 17,
					color: 'rgba(51, 51, 51, 1)',
				},
			},

			ctaSectionProps: {
				paddingVertical: 15,
				width: '40%',
				alignItems: 'end',
				paddingRight: 5,

				ctaProps: {
					height: 40,
					width: 106,
					borderWidth: 1,
					borderColor: 'rgba(0, 198, 132, 1)',
					borderRadius: 8,
					backgroundColor: 'rgba(255, 255, 255, 1)',
					justifyContent: 'center',

					ctaTextProps: {
						fontSize: 14,
						fontWeight: 600,
						lineHeight: 17,
						textAlign: 'center',
						color: 'rgba(0, 198, 132, 1)',
					},
				},

				activeCtaProps: {
					height: 40,
					width: 106,
					borderRadius: 8,
					backgroundColor: 'rgba(0, 198, 132, 1)',
					justifyContent: 'center',

					activeCtaTextProps: {
						fontSize: 14,
						fontWeight: 600,
						lineHeight: 17,
						textAlign: 'center',
						color: 'rgba(255, 255, 255, 1)',
					},
				},
			},
		},
	},
	desktop: {
		padding: 24,
		display: 'flex',
		borderWidth: 1,
		borderColor: 'rgba(240, 240, 240, 1)',
		borderRadius: 12,
		width: '100%',
		minHeight: 236,
		imageSectionProps: {
			width: '30%',

			imageProps: {
				position: 'absolute',
				top: 0,
				display: 'block',
				cursor: 'pointer',
				width: '100%',
				height: 188,
				borderRadius: 8,
			},
		},

		detailsSectionProps: {
			width: '100%',
			paddingLeft: 32,
			resortProps: {
				paddingTop: 5,
				fontSize: 20,
				fontWeight: 600,
				lineHeight: 25,
				color: 'rgba(51, 51, 51, 1)',
			},

			amenitiesProps: {
				display: 'flex',
				minHeight: 20,
				maxWidth: 350,
				flexWrap: 'wrap',

				amenitiesItemProps: {
					paddingRight: 13,
					paddingTop: 10,
				},
				amenitiesIconProps: {
					width: 18,
					height: 18,
					fill: 'rgba(0, 0, 0, 0.5)',
				},

				amenitiesTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 18,
					color: 'rgba(51, 51, 51, 1)',
				},
			},

			viewMoreProps: {
				display: 'flex',
				paddingTop: 10,
				paddingLeft: 3,

				viewMoreTextProps: {
					fontSize: 14,
					fontWeight: 600,
					lineHeight: 18,
					color: 'rgba(51, 51, 51, 1)',
				},
				viewMoreIconProps: {
					width: 14,
					height: 14,
					fill: 'rgba(51, 51, 51, 1)',
				},
			},
		},
		specialInclusionProps: {
			width: '100%',
			paddingLeft: 22,
			paddingTop: 16,
			paddingBottom: 20,
			backgroundColor: 'rgba(208, 244, 229, 1)',
			borderRadius: 12,

			specialInclusionHeadingProps: {
				fontSize: 15,
				fontWeight: 600,
				lineHeight: 22,
				color: 'rgba(0, 119, 79, 1)',
				paddingBottom: 12,
			},

			specialInclusionIconProps: {
				width: 15,
				height: 15,
			},
			specialInclusionTextProps: {
				fontSize: 14,
				lineHeight: 22,
				fontWeight: 400,
				minHeight: 25,
				maxWidth: '100%',
			},
		},
		priceSectionProps: {
			direction: 'column',
			width: '100%',
			paddingLeft: 32,

			leftSectionProps: {
				width: '60%',

				priceTextProps: {
					fontSize: 17,
					fontWeight: 700,
					lineHeight: 22,
					color: 'rgba(51, 51, 51, 1)',
					paddingBottom: 12,
				},

				inclusionTextProps: {
					fontSize: 14,
					fontWeight: 400,
					lineHeight: 17,
					color: 'rgba(51, 51, 51, 1)',
				},
			},

			ctaSectionProps: {
				width: '40%',
				alignItems: 'end',
				paddingRight: 5,

				ctaProps: {
					height: 40,
					width: 106,
					borderWidth: 1,
					borderColor: 'rgba(0, 198, 132, 1)',
					borderRadius: 8,
					backgroundColor: 'rgba(255, 255, 255, 1)',
					justifyContent: 'center',

					ctaTextProps: {
						fontSize: 14,
						fontWeight: 600,
						lineHeight: 17,
						textAlign: 'center',
						color: 'rgba(0, 198, 132, 1)',
					},
				},

				activeCtaProps: {
					height: 40,
					width: 106,
					borderRadius: 8,
					backgroundColor: 'rgba(0, 198, 132, 1)',
					justifyContent: 'center',

					activeCtaTextProps: {
						fontSize: 14,
						fontWeight: 600,
						lineHeight: 17,
						textAlign: 'center',
						color: 'rgba(255, 255, 255, 1)',
					},
				},
			},
		},
	},
}

export const toggle = {
	default: {
		width: 44,
		height: 24,
		borderRadius: 25,
		startLeft: 2,
		endLeft: 44 - (24 - 4) - 2,
		backgroundColor: '#65656B',
		activeProps: {
			backgroundColor: 'rgba(0, 198, 132, 1)',
		},
		disabledProps: {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
}

export const badge = {
	default: {
		dotProps: {
			width: 8,
			height: 8,
			backgroundColor: '#00B277',
		},
		countProps: {
			color: '#FFFFFF',
			fontSize: 11,
			height: 16,
			minWidth: 16,
			display: 'flex',
			alignItems: 'center',
			jusitfyContent: 'center',
			lineHeight: 0,
			paddingHorizontal: 6,
			backgroundColor: '#00B277',
			borderRadius: 8,
		},
	},
}
